import { LocaleIdentifier } from '@repo/markets/types'
import { LinkType } from '@repo/sanity/shorthand'
import { ReadonlyURLSearchParams } from 'next/navigation'

export const createHrefWithQuery = (pathname: string, params: URLSearchParams | ReadonlyURLSearchParams): Readonly<string> => {
  const paramsString = params.toString()
  const queryString = `${paramsString.length ? '?' : ''}${paramsString}`

  return `${pathname}${queryString}`
}

export const createHrefForLink = (link: LinkType, locale: LocaleIdentifier) => {
  const isInternalLink = link?.type === 'internal' && 'internalLink' in link
  const title = (isInternalLink ? link.internalLink?.title || link?.label : link?.label) || undefined

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const href = isInternalLink ? createHrefForDocument(link.internalLink?._type, link.internalLink?.urlSlug?.current, locale) : (link as any)?.url

  return { title, href }
}

export const createHrefForDocument = (rawDocumentType: string | unknown, rawUrlSlug: string | unknown, locale: LocaleIdentifier): Readonly<string> => {
  if (rawDocumentType === undefined || rawUrlSlug === undefined) {
    return `/${locale}`
  }

  // We take a defensive approach, the props are unknown but try to always return a href.
  const documentType = String(rawDocumentType)
  const urlSlug = String(rawUrlSlug)

  // Mapping of Sanity document _type to href.
  switch (documentType) {
    case 'article':
      return `/${locale}/internet/${urlSlug}`
    case 'blogSettings':
      return `/${locale}/${urlSlug}`
    case 'product':
      return `/${locale}/product/${urlSlug}`
    case 'productPreview':
      // Whilst we do not expect a type of productPreview,
      // consider this defensive programming.
      return `/${locale}/product/${urlSlug}`
    case 'collection':
      return `/${locale}/collection/${urlSlug}`
    case 'page':
      // Homepage
      if (urlSlug === '/') {
        return `/${locale}`
      }

      return `/${locale}/${urlSlug}`
    default:
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Unknown document type:', documentType)
      }

      return `/${locale}/${urlSlug}`
  }
}
